module.exports = __webpack_public_path__ + "static/media/clark-street-merc.4e443266.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/clark-street-merc.jpg
// module id = 1057
// module chunks = 0